import { useEffect } from 'react'
import { Operation } from 'fast-json-patch'
import { useTranslation } from 'react-i18next'

import { useUpdateProfile } from '../../../../hooks/profile/useUpdateProfile'

import { Card } from '../../../card/Card'
import NotificationsForm from '../preferences/preferenceComponents/NotificationForm'

import { useApp } from '../../../../contexts/AppContext'
import { useProfileContext } from '../../../../contexts/ProfileContext'
import { UserProfile } from '../../../../types/user/userProfile'
import { BannerKind } from '../../../../types/contexts/AppContext'

type NotificationsProps = {
  profile: UserProfile | null
}

/** Which messages the customer receives (email, push, marketing); each switch is saved as soon as it changes. */
const Notifications = ({ profile }: NotificationsProps) => {
  const { t } = useTranslation('account')
  const { showBanner } = useApp()
  const { updateLocalProfile } = useProfileContext()
  const { updateProfile, loading, error, success, resetState } = useUpdateProfile()

  useEffect(() => {
    if (error) {
      showBanner({ kind: BannerKind.ERR, msg: error })
    }
    if (success) {
      showBanner({ kind: BannerKind.OK, msg: success })
    }
    resetState()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error, success])

  const handleSave = async (patch: Operation[]) => {
    if (patch.length === 0) {
      return
    }
    const updatedProfile = await updateProfile(patch, t('account.hook.notifications.saved'))
    if (updatedProfile) {
      updateLocalProfile(updatedProfile)
    }
  }

  return (
    <Card className="col-12 responsive-half-card">
      <NotificationsForm profile={profile} loading={loading} onSave={handleSave} />
    </Card>
  )
}

export default Notifications
